<template>
	<div class="container card w-auto">
		<div class="card-header p-3 py-5">
			<p class="name">{{ templateData?.campaignName }}</p>
			<i class="icon bi bi-x" @click="$emit('hideTemplate')"></i>
		</div>

		<div class="card-body p-3">
			<TemplatePreview
				:form="templateData?.form"
				:type="templateData?.type"
				bgColor="#FAE4CB"
				:showTitle="false"
				:showSubTitle="false"
			/>
		</div>
		<div></div>
	</div>
</template>

<script setup>
import TemplatePreview from '@/v2/modules/whatsapp/pages/templates/create-edit/components/template-preview.vue';
import { computed } from 'vue';

const props = defineProps({
	data: {
		type: Object,
		default: {},
	},
});
const templateData = computed(() => {
	const template = props.data?.extra_data?.campaign?.whatsapp_template;
	const components = template?.components;
	const header = components?.find((el) => el?.type === 'HEADER');
	const body = components?.find((el) => el?.type === 'BODY');
	const footer = components?.find((el) => el?.type === 'FOOTER');
	const buttons = components?.find((el) => el?.type === 'BUTTONS');

	return {
		campaignName: props.data?.extra_data?.campaign?.name,
		form: {
			header: {
				format: header?.format,
				text: header?.text,
				image_url: props.data?.extra_data?.campaign?.image_url,
			},
			body: {
				text: body?.text,
				example: body?.example,
			},
			footer: {
				text: footer?.text,
			},
			buttons: {
				buttons: buttons?.buttons,
			},
		},
		type: template?.type,
	};
});
</script>

<style scoped lang="scss">
@import './Profile/styles/index.scss';
.card-header {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #efefef !important;
	margin-bottom: 30px;
	.name {
		font-size: 18px;
		color: #101828;
		font-weight: 600;
		margin-bottom: 0;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		max-width: 80%;
	}
	.icon {
		&:before {
			color: #98a2b3;
			font-size: 24px;
		}
	}
}
</style>
